import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12d6e17c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "desktop-footer__copyright" }, " تمامی حقوق این سرویس متعلق به مجموعه پی سرا است ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_desktop_footer_social = _resolveComponent("desktop-footer-social")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_desktop_footer_social)
  ]))
}